import {useSelector} from 'react-redux';

import * as selectors from 'pages/Template/slice/selectors';
import {PROGRESS_STATUSES} from 'pages/Template/constants';

const useTemplateState = () => {
    const status = useSelector(selectors.getStatus);
    const statusConnection = useSelector(selectors.getStatusConnection);
    const connectionValid = useSelector(selectors.getConnectionValidate);
    const templateData = useSelector(selectors.getTemplateData);

    return {
        isSuccess: status === PROGRESS_STATUSES.FULFILLED,
        isError: status === PROGRESS_STATUSES.REJECTED,
        isLoadingConnect: statusConnection === PROGRESS_STATUSES.PENDING,
        isLoadingSign: status === PROGRESS_STATUSES.PENDING,
        connectionValid,
        templateData,
    };
};

export default useTemplateState;
